<template>
  <b-card no-body id="tabs-container">
    <!-- :::::::::::::::::::::::::::: NOTIFICADOR :::::::::::::::::::::::::::: -->
    <notificador-card />
    <b-tabs active-nav-item-class="font-weight-bold text-primary" card>
      <!-- :::::::::::::::::::::::::::: LAUDO TÉCNICO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('LT')">
        <laudotecnico-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: PLANO DE MANUTENÇÃO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('PLM')">
        <planomanutencao-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: CHECKLIST :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('CK')">
        <checklist-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: CERTIFICADO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('CERTIFICADO')">
        <certificado-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: REGISTRO FOTOGRAFICO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('RF')">
        <registrofotografico-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: RELATORIO DE INSPECAO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('RI')">
        <relatorioinspecao-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: PARTICULAS MAGNETICAS :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('PM')">
        <particulamagnetica-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: PARTICULAS MAGNETICAS :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('LP')">
        <liquidopenetrante-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: MEDIÇÃO DE ESPESSURA ::::::::::::::::::::::::::::: -->
      <div v-if="isOpen('ME')">
        <medicaoespessura-tablist />
      </div>
      <!-- :::::::::::::::::::::::: TESTE DE CARGA / HIDROSTÁTICO :::::::::::::::::::::::: -->
      <div v-if="isOpen('TE')">
        <teste-tablist />
      </div>
    </b-tabs>
  </b-card>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import Notificador from "../supports/Notificador";
import LaudoTecnicoReport from "@/components/reports/laudo_tecnico/LaudoTecnicoReport";
import PlanoManutencaoReport from "@/components/reports_forms/PlanoManutencaoReport";
import ChecklistReport from "@/components/reports_forms/ChecklistReport";
import CertificadoReport from "@/components/reports_forms/CertificadoReport";
import RegistroFotograficoReport from "@/components/reports_forms/RegistroFotograficoReport";
import RelatorioInspecaoReport from "@/components/reports_forms/RelatorioInspecaoReport";
import ParticulaMagneticaReport from "@/components/reports_forms/ParticulaMagneticaReport";
import LiquidoPenetranteReport from "@/components/reports_forms/LiquidoPenetranteReport";
import MedicaoEspessuraReport from "@/components/reports_forms/MedicaoEspessuraReport";
import TesteReport from "@/components/reports_forms/TesteReport";

export default {
  name: "CertificadoTabsPanel",

  components: {
    "notificador-card": Notificador,
    "laudotecnico-tablist": LaudoTecnicoReport,
    "planomanutencao-tablist": PlanoManutencaoReport,
    "checklist-tablist": ChecklistReport,
    "certificado-tablist": CertificadoReport,
    "registrofotografico-tablist": RegistroFotograficoReport,
    "relatorioinspecao-tablist": RelatorioInspecaoReport,
    "particulamagnetica-tablist": ParticulaMagneticaReport,
    "liquidopenetrante-tablist": LiquidoPenetranteReport,
    "medicaoespessura-tablist": MedicaoEspessuraReport,
    "teste-tablist": TesteReport,
  },

  data() {
    return {};
  },

  methods: {
    isOpen(report) {
      let temReport = false;
      this.reports.findIndex((value) => {
        if (value.tipo == report) {
          temReport = true;
        }
      });
      return temReport;
    },
  },

  setup() {
    const store = useSgcqStore();
    return {
      store,
      reports: store.getReports,
    };
  },
};
</script>

<style lang="scss" scoped>
#tabs-container {
  display: inline-block;
  width: 80%;
  vertical-align: top;
  overflow-x: hidden;
  min-width: 80%;
  height: 99vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>
